export const ADMIN_PERMISSION_MODULES = [
  { key: "dashboard", label: "Dashboard", actions: ["view"] },
  { key: "sub_admin", label: "Sub-Admin", actions: ["view", "add", "edit", "delete"] },
  { key: "pending_student", label: "Pending Student", actions: ["view", "approve", "reject"] },
  { key: "student_list", label: "Student List", actions: ["view", "edit", "deactivate", "activate", "delete"] },
  { key: "course", label: "Course", actions: ["view", "add", "edit", "delete"] },
  { key: "subject", label: "Subject", actions: ["view", "add", "edit", "delete"] },
  { key: "module", label: "Module", actions: ["view", "add", "edit", "delete"] },
  { key: "question", label: "Question", actions: ["view", "add", "edit", "delete"] },
  { key: "ai_explanation", label: "AI Explanation", actions: ["view", "generate", "edit", "delete", "regenerate"] },
  { key: "ai_learning_monitor", label: "AI Learning Monitor", actions: ["view", "generate_insight", "export"] },
  { key: "enrollment_request", label: "Enrollment Requests", actions: ["view", "approve", "reject"] },
  { key: "temporary_access_students", label: "Temporary Access Students", actions: ["view", "view_receipt", "verify_payment", "reject_payment", "grant_permanent_access", "confirm_payment_manually", "extend_access", "reset_question_limit"] },
  { key: "support", label: "Support", actions: ["view", "reply", "resolve"] },
  { key: "push_broadcast", label: "Push Broadcast", actions: ["view", "send"] },
  { key: "share_analytics", label: "Share Analytics", actions: ["view"] },
  { key: "settings", label: "Settings", actions: ["view", "edit"] },
];

export function hasPerm(user, module, action = "view") {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  const perms = user.permissions || {};
  return Boolean(perms?.[module]?.[action]);
}
